import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveImage from '../ResponsiveImage';
import RichText from '../Prismic/RichText';
import CallToAction from './CallToAction';

import './Hero.scss';

const Link = props => {
  if (!props.ctaLink) {
    return props.children;
  }
  return (
    <a href={props.ctaLink}>
      {props.children}
    </a>
  );
};

const Hero = props => (
  <section className="hero">
    <Link ctaLink={props.ctaLink}>
      <div className="hero-image">
        <ResponsiveImage images={props.backgroundImage} />
      </div>
      <div className="hero-wrapper">
        <div className="container-guttered">
          <RichText
            className="hero-content"
            fields={props.content}
            color={props.contentColor}
          />
          {props.cta && props.ctaLink && (
            <CallToAction
              cta={props.cta}
              color={props.contentColor}
            />
          )}
        </div>
      </div>
    </Link>
  </section>
);

Hero.propTypes = {
  backgroundImage: PropTypes.shape({
    dimensions: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    }).isRequired,
    alt: PropTypes.string,
    copyright: PropTypes.string,
    url: PropTypes.string.isRequired,
  }).isRequired,
  content: PropTypes.array.isRequired,
  contentColor: PropTypes.string,
  cta: PropTypes.string.isRequired,
  ctaLink: PropTypes.string.isRequired,
  ctaColor: PropTypes.string,
};

Link.propTypes = {
  children: PropTypes.node.isRequired,
  ctaLink: PropTypes.string,
};

export default Hero;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Hero/Hero.js